import { Component, Input } from '@angular/core';

@Component({
  selector: 'layout-wrapper',
  templateUrl: './layout-wrapper.component.html',
  host: { 'class': 'container-fluid' },
  styleUrls: ['./layout-wrapper.component.scss'],
})
export class LayoutWrapperComponent {
  @Input() bottomBorder: boolean = false;
  @Input() customStyles: string = '';

  // get classes(): string {
  //   return `${this.class}${this.bottomBorder ? ' bottom-border' : ''}`
  // }
}
